// extracted by mini-css-extract-plugin
export default {"screensaver":"Screensaver_screensaver__H5AgH","video":"Screensaver_video__Y0e5H","expired":"Screensaver_expired__OCuER","overlay":"Screensaver_overlay__Vdom-"};